// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

export class Controller {
    /** @ngInject */
    constructor(ApprovalPoliciesService, ConfirmDeleteModal, $state, Alert, CompanyUser) {
        this.ApprovalPoliciesService = ApprovalPoliciesService;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.$state = $state;
        this.Alert = Alert;
        this.CompanyUser = CompanyUser;
    }

    $onInit() {
        this.$policy = angular.copy(this.policy);
        this.$policy.companyPolicyType = 'ApprovalPolicy';
    }

    saveDisabled(form) {
        return form.$invalid || (this.policy.policyName === this.$policy.policyName && this.policy.approvalType === this.$policy.approvalType && this.approvalManagerRequired() && !this.approvalManagerModified()) || this.approvalManagerRequired() && this.$policy.approvalManagers.length <= 0;
    }

    approvalManagerModified() {
        return !angular.equals(this.policy.approvalManagers, this.$policy.approvalManagers);
    }

    approvalManagerRequired() {
        return this.$policy.approvalType.includes('APPROVAL_MANAGER');
    }

    companyUserSearchVisible() {
        return this.approvalManagerRequired();
    }

    save() {
        this.isSaving = true;
        this.ApprovalPoliciesService.updatePolicy(this.$policy, this.companyId)
            .then((policy) => {
                this.Alert('success', 'global.messages.operation-successful');
                this.$state.reload('company.request-center');
                this.policy = policy;
                this.$policy = angular.copy(this.policy);
            })
            .finally(() => this.isSaving = false);
    }

    isLoading() {
        return this.isDeleting || this.isSaving;
    }

    remove() {
        this.ConfirmDeleteModal('Are you sure you want to delete this approval policy')
            .then(() => {
                this.isRemoving = true;
                this.ApprovalPoliciesService.deletePolicy(this.policy.id, this.companyId)
                    .then(() => this.$state.go('company.request-center.policies.list', {}, {reload: 'company.request-center'}))
                    .finally(() => this.isRemoving = false);
            })
    }

    deleteApprovalManager(manager) {
        this.$policy.approvalManagers.splice(this.$policy.approvalManagers.indexOf(manager), 1);
    }

    addApprovalManager() {
        if(this.companyUserIsAlreadyInList(this.companyUser)) {
            this.Alert('danger', 'User is already in the approver list.');
        } else {
            this.$policy.approvalManagers.push(this.companyUser);
        }
        this.cancelSearch();
    }

    companyUserIsAlreadyInList(companyUser) {
        return this.$policy.approvalManagers.filter((manager) => manager.id == companyUser.id).length > 0;
    }

    identifyUser() {
		this.message = null;
		this.userIdentifier = this.newUserIdentifier;

		this.CompanyUser.identifyCompanyUser({
			companyId: this.companyId,
			uid: encodeURIComponent(this.userIdentifier)
		}).$promise
			.then((response) => {

				this.successResult = true;
				this.showVerification = false;
				this.companyUser = response;
                this.companyUser.saaspassId = this.companyUser.saaspassUser.saaspassId;
				this.message = 'groups_users.user_found';
			})
			.catch((error) => {
				this.successResult = false;
				this.companyUser = null;

				this.showVerification = this.enableVerification && !this.successResult
					&& $rootScope.emailPattern.test(this.userIdentifier);

				if (error.status == 404) {
					this.message = 'groups_users.user_not_found';
				} else {
					this.message = response.data.message;
				}
			})
	}

    cancelSearch() {
		this.userIdentifier = null;
		this.successResult = null;
		this.showVerification = false;
		this.companyUser = null;
		this.message = null;
		this.newUserIdentifier = null;
	}
	
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/edit/approval-policies-edit.controller.js